import { render, staticRenderFns } from "./CustomerPointList.vue?vue&type=template&id=7ad7ae6b&scoped=true&"
import script from "./CustomerPointList.vue?vue&type=script&lang=js&"
export * from "./CustomerPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7ae6b",
  null
  
)

export default component.exports